import React, { ReactElement } from 'react';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';

// Components

import UniversalInput from '@lib/wrappers/UniversalInput';

// Utils

import { getStateName } from '@utils/normalize/getStateName';


// Constants

import { INPUT_TYPES } from '@constants/inputs/inputTypes';
import { VALIDATION_TYPES } from '@constants/inputs/validationTypes';

// Types

import { IExchangeProgramNames, SsapData } from '@components/ssap/SsapTypes';
import { STATES_TYPE } from '@constants/configs/states';

interface IReadyReportChangesAttestation {
    actions: {
        onFieldChange_data: Function
    },
    data: SsapData,
    exchangeName: string,
    exchangeAndProgramNames: IExchangeProgramNames,
    formName: string,
    isAsteriskShown: boolean,
    isFinancialFlow: boolean,
    PHONE: string,
    stateCode: STATES_TYPE
}


const ReadyReportChangesAttestation = (props: IReadyReportChangesAttestation): ReactElement => {
    const {
        actions: {
            onFieldChange_data
        },
        data,
        data: {
            legalAttestations: {
                changeInformationAgreementIndicator
            }
        },
        exchangeName,
        exchangeAndProgramNames,
        formName,
        isAsteriskShown = true,
        isFinancialFlow,
        PHONE,
        stateCode
    } = props;
    const { exchangeMedicaidOrChip } = exchangeAndProgramNames;

    const className = classNames({
        'required-true': isAsteriskShown
    });

    const getTextReplacement = () => {
        switch(true) {
            case isFinancialFlow:
                return (
                    <span className = { className } >
                        <FormattedMessage
                            id = 'ssap.sign_and_review.ready_report_changes'
                            values = { {
                                exchangeName
                            } }
                        />
                    </span>
                );
            default:
                return (
                    <span className = { className } >
                        <FormattedMessage
                            id = 'ssap.sign_and_review.ready_report_changes_non_ff'
                            values = { {
                                exchangeName
                            } }
                        />
                    </span>
                );
        }
    };

    return (
        <UniversalInput
            label = { {
                text: 'common.input.label.non_internationalized_text',
                labelTextReplacements: {
                    text: getTextReplacement()
                },
                dataInstructions: 'instructional_text.sign_submit_changes_report_duty',
                instructionsViaPortal: [ true ],
                replacements: {
                    exchangeName,
                    phone: PHONE,
                    stateCode: getStateName(stateCode),
                    exchangeMedicaidOrChip
                }
            } }
            inputData = { {
                isInputRequired: true,
                type: INPUT_TYPES.CHECKBOX,
                classes: [ 'disp-styl-none' ],
                name: 'changeInformationAgreementIndicator',
                checked: changeInformationAgreementIndicator,
                value: changeInformationAgreementIndicator,
                validationType: VALIDATION_TYPES.CHECKED,
                currentData: data,
                fields: [ 'legalAttestations' ]
            } }
            errorClasses = { ['margin-l-0'] }
            inputActions = { {
                onFieldChange: onFieldChange_data
            } }
            underFormControl
            parentForm = { { name: formName } }
        />
    );
};

export default ReadyReportChangesAttestation;